import { useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";

import { AuthService } from "src/common/AuthService";
import { StaffRole } from "src/common/types";

export const RoleGate = ({ role }: { role: StaffRole }) => {
  const navigate = useNavigate();
  const staffUserRole = AuthService.hooks.useStaffUserRole();

  useEffect(() => {
    if (staffUserRole !== role) {
      navigate("/");
    }
  }, []);

  return <Outlet />;
};
